const FileContentUploader = require('../../../ui/tool-menu/components/mixins/file-content-uploader');
const UploadThumbnailView = require('../../../ui/tool-menu/components/thumbnail/upload');
const LibraryFactory = require('../../library').instance;

module.exports = _.extend({
  getNewItem: function (data, el, copyResource = false) {
    const deferred = $.Deferred();

    copyResource
      ? deferred.resolve({ type: data.is_vector ? 2 : 1, source: data.thumb_src })
      : this.procesSVGResource(deferred, el);

    return deferred.promise();
  },

  procesSVGResource: function (deferred, el) {
    const svgContent = this.generateSVGFile(el);

    this.initUpload();
    this.uploadFileContent(svgContent, { type: 'image/svg+xml;charset=utf-8' });

    $(document).one('file-content-upload:error', deferred.reject);
    $(document).one('file-content-upload:complete', function (event, source, fileName) {
      deferred.resolve({
        type: 2,
        source: source,
        name: fileName,
        is_banner: !!$(el).find('>.textarea').length
      });
    });
  },

  generateSVGFile: function (el) {
    const bbox = svgedit.utilities.getBBox(el);

    const x = Math.floor4(bbox.x);
    const y = Math.floor4(bbox.y);
    const width = Math.floor4(bbox.width);
    const height = Math.floor4(bbox.height);
    const viewBox = `viewBox="${x} ${y} ${width} ${height}"`;

    let xml = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" charset="utf-8"';
    xml += ` height="${height}" width="${width}" x="0" y="0" ${viewBox}>\n`;
    xml += INKIVE.Helpers.serializeToString(el) + '\n</svg>';

    return xml;
  },

  isSameModel: function (model1, model2) {
    return model1.type === model2.type &&
      model1.source === model2.source;
  },

  initUpload: function () {
    this.uploadPath = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE
      ? '/company/assets/' + pad(LibraryFactory.companyData.id, 10) + '/' + this.getType()
      : '/library/' + INKIVE.C.USER.id + '/' + this.getType();

    _.bindAll(this,
      'complete',
      'errorEvent',
      'getUploadKey',
      'completeEvent',
      'uploadFileContent'
    );

    this._addUploadThumbnail();
    this.initializeUpload();

    function pad (num, size) {
      size = size || 2;
      const s = '0000000000000000' + num;
      return s.substr(s.length - size);
    }
  },

  getType: function () {
    // TODO: overwrite on logo extension if adding logo from sticker is allowed
    return 'icon';
  },

  _addUploadThumbnail: function () {
    this.$el = $('body');
    this.$el.append($('<ul class="uploader-wrapper hidden"></ul>'));

    const $thumbnailWrapper = this.$el.find('.uploader-wrapper');

    this.$uploaderThumbnail = $('<div></div>').addClass('thumbnail uploader');

    $thumbnailWrapper.append(this.$uploaderThumbnail);
    this.views = {};

    this.views.uploadThumbnail = new UploadThumbnailView({
      el: this.$uploaderThumbnail
    });
  }
}, FileContentUploader);
